import ScrollableView from '@/shared/components/ScrollableView';
import React from 'react';
import { View, ViewStyle } from 'react-native';
import { useSafeAreaInsets } from 'react-native-safe-area-context';
import { sand } from '../colors';

export default function ModalWrapper({
  children,
  isScrollable,
  includeBottomPadding,
  style = {},
}: {
  children: React.ReactNode;
  isScrollable?: boolean;
  includeBottomPadding?: boolean;
  style: ViewStyle;
}) {
  const Wrapper = isScrollable ? ScrollableView : View;
  const insets = useSafeAreaInsets();
  return (
    <Wrapper
      style={{
        paddingTop: insets.top,
        backgroundColor: sand,
        paddingBottom: includeBottomPadding ? insets.bottom : 0,
        ...style,
      }}
    >
      {children}
    </Wrapper>
  );
}
